import { SYSFormField } from "../../../../_ovlclient/src/library/forms/fieldapi"

export let SYSEditorAssetDefaultFields: { [key: string]: SYSFormField } = {
  // these are the global fields for all the files uploaded
  SelectedFiles: { ui: { noLabel: true } },
  // <set it in FormInit>
  ValidExtensions: { ui: { noLabel: true } },
  // set this to 0 if there should be no file upload at all (just a link eg.).
  // It should be 1 if there is one file per field and row.
  // it should be > 1 if there one day will be multiple files per field and row (not handled in the defaultform editor)
  // for now just one attachment per field is supported with the default AssetConfig Editor. But it can be changed
  AllowUpload: { type: "int", ui: { noLabel: true } },
  //</set it in FormInit>

  // why _00?: if one day we have more than 1 attachment per field per row.
  // this should enable us to handle up to 100 attacchments per field in a form
  Category_00: {
    inactive: true,
    list: {
      mode: "Select",
      displayField: "CatDesc",
      valueField: "CatId",
      acceptOnlyListValues: true,
      displayValueField: false,
    },
    schema: { nullable: false },
    ui: {
      visible: "false",
    },
  },
  Val_00: {
    ui: { selectIfFocused: true },
  },
  // Chk0 will be serialzed to c:"1" for true and c:"0" for false.
  // So if you have more checkboxes you could also use a SYSEditorAssetChk1 and so on and refelct it in the serialization like c:"11"
  Chk0_00: {
    type: "bool",
    value: false,
    inactive: true,
    ui: {
      visible: "false",
    },
  },
  Desc_00: {
    inactive: true,
    ui: {
      visible: "false",
    },
  },
  Ext_00: {
    ui: { noLabel: true, readonly: true },
  },
}
